module.exports = __webpack_public_path__ + "static/media/group4080@2x.2edb1420.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/group4080@2x.png
// module id = 583
// module chunks = 1